import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import moment from "moment";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import capitalise from "utils/capitalise";
import SlotEdit from './SlotEdit';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  },
  statsContainer: {
    display: 'flex'
  },
  statsItem: {
    padding: theme.spacing(3),
    flexGrow: 1,
    '&:first-of-type': {
      borderRight: `1px solid ${theme.palette.divider}`
    }
  },
}));


const SlotInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.slot);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Slot Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Name (ZH)</TableCell>
              <TableCell>{model.name_zh}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Type</TableCell>
              <TableCell>{capitalise(model.type)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Status</TableCell>
              <TableCell>{capitalise(model.status)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Start at</TableCell>
              <TableCell>{moment(model.start_at).format("DD/MM/YYYY - HH:mm")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>End at</TableCell>
              <TableCell>{moment(model.end_at).format("DD/MM/YYYY - HH:mm")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Duration</TableCell>
              <TableCell>{model.duration / 60} min</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Limit</TableCell>
              <TableCell>{model.limit || "None"} </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <SlotEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

SlotInfo.propTypes = {
  className: PropTypes.string,
};

export default SlotInfo;
